import { LTSimpleAnimator } from "../../../LTGame/Anim/LTSimpleAnimator";
import { LTUtils } from "../../../LTGame/LTUtils/LTUtils";
import { TransformEx } from "../../../LTGame/LTUtils/TransformEx";
import Vector3Ex from "../../../LTGame/LTUtils/Vector3Ex";
import { P2Manager } from "../../../LTGame/Physics/P2Manager";
import LTRes from "../../../LTGame/Res/LTRes";
import GlobalUnit from "../../common/GlobalUnit";
import LayerDefine from "../../common/LayerDefine";
import ResDefine from "../../common/ResDefine";
import AudioManager from "../../manager/AudioManager";
import { EffectManager } from "../../manager/EffectManager";
import MaterialManager from "../../manager/MaterialManager";
import AmmoBase from "./AmmoBase";
export var EAnimType;
(function (EAnimType) {
    EAnimType[EAnimType["Idle"] = 0] = "Idle";
    EAnimType[EAnimType["Move_att"] = 1] = "Move_att";
    EAnimType[EAnimType["Idle_att"] = 2] = "Idle_att";
    EAnimType[EAnimType["Die"] = 3] = "Die";
})(EAnimType || (EAnimType = {}));
export default class ViewPlayer {
    constructor(config, root) {
        this._blnSend = true;
        this.config = config;
        this.root = root;
        this.Dead = false;
        this.offset = new Laya.Vector3();
        this.cacheOffset = new Laya.Vector3();
        this.CreateModel();
        this.CreateBody();
        this.UpdateAnimScale();
    }
    UpdateAnimScale() {
        let scale = GlobalUnit.game.player.GetSkill(1);
        this.bodyAnim.speed = scale;
    }
    CreateModel() {
        console.log(this.config);
        this.model = LTRes.Get(ResDefine.FixPath(this.config.role_model));
        // this.root.addChild(this.model);
        GlobalUnit.game.level.AddItemToLevel(this.model);
        TransformEx.ResetLocalTrans(this.model.transform);
        let anim = LTUtils.GetComponentsInChildren(this.model, Laya.Animator);
        this.bodyAnim = new LTSimpleAnimator(anim[0]);
        this.bodyAnim.updateImd = true;
        this.sendPoint = LTUtils.FindChild(this.model, this.config.send_point);
        this.render = LTUtils.FindChild(this.model, this.config.skin);
    }
    CreateBody() {
        let body = this.model.getChildByName("body");
        this.body = P2Manager.instance.CreateBody(body, LayerDefine.Player, LayerDefine.Item | LayerDefine.Enemy, p2.Body.DYNAMIC);
        P2Manager.instance.AddBody(this.body);
        this.body["use"] = this;
    }
    BeginContact(other) {
        let config = other.config;
        switch (config.item_type) {
            case 3:
                if (!GlobalUnit.game.player.GetHaveSuper()) {
                    this.DoDie();
                }
                break;
            case 4:
                GlobalUnit.game.tryPetId = config.item_value;
                GlobalUnit.game.pet.ChangeSkin(config.item_value);
                other.Destroy();
                break;
        }
    }
    PlayMoveToBlack(trans) {
        let oldTrans = this.model.transform;
        let diff = Vector3Ex.Subtract(oldTrans.position, trans.position);
        let dist = Vector3Ex.Distance2D(Vector3Ex.s_zero, diff);
        Laya.Tween.to(oldTrans, {
            localPositionX: oldTrans.localPositionX - diff.x,
            localPositionY: oldTrans.localPositionY - diff.y,
            localPositionZ: oldTrans.localPositionZ - diff.z,
            localScaleX: 0,
            localScaleY: 0,
            localScaleZ: 0,
        }, dist * 0.5 * 1000, Laya.Ease.backInOut);
    }
    SendAmmo() {
        if (this.config.eff_id) {
            EffectManager.instance.PlayEffectById(this.config.eff_id, 2, this.sendPoint.transform.position);
        }
        AudioManager.instance.PlayById(2);
        let ammo = new AmmoBase(this.sendPoint, this.config);
        // console.log(ammo);
        GlobalUnit.game.player.AddAmmo(ammo);
    }
    OnIdle() {
        this.playerState = EAnimType.Idle;
        this.ResetAnim();
    }
    OnStart() {
        this.playerState = EAnimType.Move_att;
        this.ResetAnim();
    }
    OnFighted() {
        this.playerState = EAnimType.Idle_att;
        this.ResetAnim();
    }
    DoDie() {
        LTUtils.Vibrate(false);
        this.OnDie();
        GlobalUnit.game.player.RemovePlayer(this);
        GlobalUnit.game.player.DelayUpdatePos();
    }
    OnDie() {
        this.Dead = true;
        this.bodyAnim.speed = 1;
        let render;
        if (this.render instanceof Laya.SkinnedMeshSprite3D) {
            render = this.render.skinnedMeshRenderer;
        }
        else {
            render = this.render.meshRenderer;
        }
        let white = MaterialManager.instance.GetWhiteMaterial(this.config.id, render.sharedMaterial, false);
        render.sharedMaterial = white;
        this.playerState = EAnimType.Die;
        P2Manager.instance.RemoveBody(this.body);
        this.body.collisionResponse = false;
        let pos = this.model.transform.position.clone();
        GlobalUnit.game.level.AddItemToLevel(this.model);
        this.model.transform.position = pos;
        this.ResetAnim();
        EffectManager.instance.PlayEffectById(4, 2, null, null, this.model);
    }
    PlayerEff(type = "up") {
        if (this.root.destroyed)
            return;
        if (type == "up") {
            EffectManager.instance.PlayEffectById(3, 2, null, null, this.model);
        }
        else if (type == "change") {
            EffectManager.instance.PlayEffectById(2, 2, null, null, this.model);
        }
    }
    ResetAnim() {
        this.SetAnim(this.playerState);
    }
    SetAnim(type) {
        this.bodyAnim.targetAnimName = this.config.actions[type];
    }
    ChangeModel(config) {
        this.config = config;
        this.model.destroy();
        this.CreateModel();
        this.ResetAnim();
        this.UpdateAnimScale();
    }
    BeginEd() {
        this.moveEd = true;
    }
    OnMoveEd() {
        this.cacheOffset = Vector3Ex.Lerp(this.cacheOffset, this.offset, 0.05);
        this.model.transform.position = Vector3Ex.Add(this.root.transform.position, this.cacheOffset);
        if (Vector3Ex.Distance2D(this.cacheOffset, this.offset) <= 0.4) {
            this.OnFighted();
        }
    }
    LerpPos() {
        this.cacheOffset = Vector3Ex.Lerp(this.cacheOffset, this.offset, 0.05);
        if (!this.model.transform)
            return;
        this.model.transform.position = Vector3Ex.Add(this.root.transform.position, this.cacheOffset);
    }
    SyncPos() {
        P2Manager.instance.SyncTransToRigXZ(this.model.transform, this.body);
    }
    CheckSend() {
        let normalSizeTime = this.bodyAnim.animators[0].getCurrentAnimatorPlayState().normalizedTime % 1;
        let sendTime = this.config.send_times[this.playerState == EAnimType.Move_att ? 0 : 1];
        if (normalSizeTime < sendTime && this._blnSend) {
            this._blnSend = false;
        }
        else if (normalSizeTime > sendTime && !this._blnSend) {
            this._blnSend = true;
            this.SendAmmo();
        }
    }
    Destroy() {
        this.root.destroy();
    }
    Update(dt) {
        if (this.root.destroyed)
            return;
        if (this.moveEd) {
            if (this.playerState != EAnimType.Idle_att) {
                this.OnMoveEd();
            }
        }
        else {
            this.LerpPos();
        }
        this.CheckSend();
        this.SyncPos();
    }
}
